<template>
  <div class="body">
    <Yukleniyor :data="lo"></Yukleniyor>
    <div class="detay">
      <div class="sayfahead tek">
        <h1>Stok İşlemleri</h1>
        <el-button type="info" size="small" class="YeniBtn" @click="YeniUrunModal=true">
          Yeni Ürün
        </el-button>
      </div>
      <div class="icerik">
        <Yukleniyor :data="lo"></Yukleniyor>
        <el-row :gutter="24">
          <el-col :span="4">
            <div class="borcliste vezne">
              <ul>
                <router-link
                  tag="li"
                  :to="'/stok/'+Stok.id"
                  v-for="Stok in Urunler"
                  active-class="Aktif">
                  <div>
                    <div class="kisiBilgi">
                      <span class="binaAd">{{ Stok.Aciklama }}</span>
                      <span class="borcAd">{{ Stok.Adi }}</span>
                    </div>
                    <div class="borcBilgi">
                      <div class="text-primary text-left" style="width: 100%"><b>Stok Adet</b>{{ Stok.Adet }}
                      </div>
                    </div>
                  </div>
                </router-link>
              </ul>
            </div>
          </el-col>
          <el-col :span="20">
            <router-view></router-view>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog
      append-to-body
      title="Yeni Ürün Ekle"
      :visible="YeniUrunModal"
      center
      width="25%">
      <a @click="YeniUrunModal=false" class="ModalKapat"><i class="el-icon-close"></i></a>
      <el-form :rules="FormHata" :model="Urun"
               @submit.prevent.native="UrunEkle"
               ref="RaporForm">
        <el-form-item label="Ürün Adı" prop="Adi">
          <el-input v-model="Urun.Adi"></el-input>
        </el-form-item>
        <el-form-item label="Ürün Açıklaması" prop="Aciklama">
          <el-input v-model="Urun.Aciklama" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="UrunEkle">Kaydet</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Yukleniyor from "../../components/Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  data() {
    return {
      lo: false,
      YeniUrunModal: false,
      Urunler: [],
      Urun: {
        Adi: '',
        Aciklama: ''
      },
      FormHata: {
        Adi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Aciklama: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },
    }
  },
  methods: {
    UrunEkle() {
      this.$refs['RaporForm'].validate((valid) => {
        if (valid) {
          this.lo = true;
          this.$store.dispatch("Post", {
            ...this.Urun, path: '_enerji/stok/urun'
          })
            .then(response => {
              this.Urun = {
                Adi: '',
                Aciklama: ''
              }
              this.SayfaYukle();
            })
        }
      })
    },
    SayfaYukle() {
      this.YeniUrunModal = false;
      this.lo = true;
      this.$store.dispatch("Get", {
        path: '_enerji/stok/urun'
      })
        .then(response => {
          this.lo = false;
          this.Urunler = response.Urunler
        })
    }
  },
  created() {
    this.SayfaYukle()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Stok/Index.vue